module.exports = "<!--<sebm-google-map class=\"sebm-google-map-container\" [latitude]=\"latitude\" [longitude]=\"longitude\">-->\r\n  <!--<sebm-google-map-marker [latitude]=\"latitude\" [longitude]=\"longitude\" [zoom]=\"5\"></sebm-google-map-marker>-->\r\n<!--</sebm-google-map>-->\r\n"


//////////////////
// WEBPACK FOOTER
// C:/NightKey/CMS/nightkey-cms/src/app/shared/g-maps/gmaps.component.html
// module id = ../../../../../src/app/shared/g-maps/gmaps.component.html
// module chunks = main